import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { createQueryClient } from './query-client';

/**
 * Every app-wide context, in one place.
 *
 * The QueryClient is created in state rather than at module scope so it is not
 * shared between tests — a module-level client leaks cached data across
 * boundaries.
 */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
